module.exports = __webpack_public_path__ + "images/fa-dollar-sign-light.svg";